import {
  getInitApi,
  getNewInitApi,
  roleGetMenus,
  checkCompany,
  getSystemUser,
} from "@/api/api";
import router from "@/router/index";
const App = {
  /**
   * 环境标识
   */
  appEnv: "",

  /**
   * 是否为超级管理员
   */
  isSuper: 0,

  /**
   * 应用ID
   */
  appId: "",

  /**
   * 目标类型：0平台级、1企业级、2门店级、3品牌店级、8内容服务商、9商品供应商
   */
  loginUserType: 1,

  /**
   * 商户ID
   */
  merchantId: 0,

  /**
   *  内容服务商 供应商ID【西亚优品使用】
   */
  csProviderId: 0,

  /**
   * 店铺ID【西亚优品使用】
   */
  shoppeId: 0,

  /**
   * 门店ID
   */
  storeId: 0,

  /**
   * 公司ID
   */
  companyId: "",

  /**
   * 供应商
   */
  supplierId: "",
  /**
   * 用户名
   */
  userName: "",

  /**
   * 手机号
   */
  mobile: "",

  /**
   * 用户名ID
   */
  userNameId: "",

  tableName: "",

  /**
   * 弹出层层级
   */
  popupLevel: 999,

  is_kefu: 0,

  kefu_id: "",

  organizeId: 0,

  newLoginType: 1,

  // 是否移动端
  deviceType: "web",
  startInit() {
    return new Promise(async (resolve, reject) => {
      try {
        const systemUser = await getSystemUser();

        // 获取登录类型 新字段 为了分别业态
        if (systemUser.code == 200) {
          this.newLoginType = systemUser.data.login_type || 1;
        }
      } catch (err) {}
      // let fn = getInitApi;
      // const isShowNewMenu = localStorage.getItem("isShowNewMenu");
      // if(isShowNewMenu == "true"){
      //   fn = getNewInitApi;
      // }
      getNewInitApi().then(async (res) => {
        if (res.code == 200) {
          const data = res.data;
          if (!data) {
            resolve([]);
            return;
          }

          data.newLoginType = this.newLoginType;

          this.appId = "359d4cd38cc56ecb";
          this.appEnv = data.app_env;
          this.merchantId = !data.objectType ? 0 : data.merchantId;
          this.loginUserType = data.objectType;
          this.isSuper = data.is_super || 0;
          this.userName = data.userName;
          this.mobile = data.mobile;
          this.is_kefu = data.is_kefu || 0;
          this.kefu_id = data.kefu_id || "";
          this.organizeId = data.organizeId;
          this.userNameId = data.id;

          switch (data.objectType) {
            case 2:
              this.storeId = data.organizeId;
              break;
            case 3:
              this.shoppeId = data.organizeId;
              break;
            case 8:
              this.csProviderId = data.organizeId;
              break;
            case 9:
              this.supplierId = data.organizeId;
          }

          localStorage.setItem("merchantId", data.merchantId);
          const roles = [] as any[];
          data.roles.forEach((item: any, index: number) => {
            if (index === 0) {
              roles.push(item);
            } else {
              const rolesIndex = roles.findIndex(
                (f: any) =>
                  f.merchantId === item.merchantId &&
                  f.organizeId === item.organizeId
              );
              if (rolesIndex === -1) {
                roles.push(item);
              }
            }
          });
          localStorage.setItem("roles", JSON.stringify(roles));
          window.initData = data;
          resolve(data.menus)
        } else {
          reject([]);
        }
      });
    });
  },
  getDeviceType() {
    if (navigator.userAgent.indexOf("Mobile") > -1) {
      this.deviceType = "mobile";
    }
  },

  /**
   * 判断该路由是否显示该按钮
   * 第一可不传，按钮标识不能和系统标识重名，
   * @param menuCode {string} 当前路由所属的系统标识 可不传
   * @param btnCode {string?} 当前按钮标识
   * @param TabCode {string?} tab栏页面标识
   * @param path {string?} 特殊情況手动传路由地址
   * @return {boolean} 该按钮是否显示
   */
  isShowBtn(menuCode: string, btnCode?: string, TabCode?: string, path?: string) {
    const codeList = ["auth", "shop", "market", "report", "crm"];
    if (!codeList.includes(menuCode)) {
      [btnCode, TabCode, path] = [menuCode, btnCode, TabCode];
    }
    menuCode = menuCode || localStorage.getItem("menuCode") || "auth";
    path = path || router.currentRoute.value.path;
    // 获取全部菜单
    const roleMenu = JSON.parse(localStorage.getItem("roleMenu") || "[]");
    // 当前按钮所属系统
    // const itemMenu = roleMenu.filter((v: any) => v.menuCode === menuCode);
    let menu = [];

    // if (itemMenu.length) {
    //   menu = getMenu(itemMenu[0].children, path);
    // } else {
      menu = getMenu(roleMenu, path);
    // }
    let flag = false;
    if (menu?.children?.length) {
      if (menu.menuType === "T") {
        const TabCodeItem = menu.children.find(
          (f: any) => f.menuCode === TabCode
        );
        this.tableName = menu.children[0].menuCode;
        if (TabCodeItem && !btnCode) {
          return true;
        }
        if (TabCodeItem?.children?.length) {
          filter(TabCodeItem);
        }
      } else {
        filter(menu);
      }
    }

    // 判断当前按钮所属的菜单
    function getMenu(system: any[], path: string): any {
      const obj = system.find((f) => f.component === path);
      if (obj) {
        // console.log(obj)
        return obj;
      } else {
        for (const f of system) {
          if (f.children?.length) {
            const itemMenu = getMenu(f.children, path);
            if (itemMenu) return itemMenu;
          }
        }
      }
    }

    function filter(data: any) {
      const index = data.children.filter((f: any) => f.menuCode === btnCode);
      if (index.length) {
        flag = true;
      }
    }
    return flag;
  },

  getMenu(system: any[], path: string) {
    const obj = system.find((f) => f.component === path);
    if (obj) {
      return obj;
    } else {
      for (const f of system) {
        if (f.children?.length) {
          const itemMenu: any = this.getMenu(f.children, path);
          if (itemMenu) return itemMenu;
        }
      }
    }
  },

    /**
   * 获取当前页面的标题
   * @param typeName tab栏标识
   * @returns {string}
   */
    getMenuName(typeName:string):string {
      let title = "";
      try{
        const menu = JSON.parse(sessionStorage.getItem("nowMenu") || '{}');
        if (menu.menuType === "T") {
          title =
            menu.children.find((f:any) => f.menuCode === typeName)?.menuName || "";
        } else {
          title = menu.menuName;
        }
      }catch(e){
        title = "标题获取错误";
      }
      return title;
    },
};

export default App;
